import { UserState } from '../redux/user/userSlice';
import { completeUserData } from './user/helper';

export const persistedUser = () => {
    if (typeof window !== 'undefined') {
        const localUser = window.localStorage?.getItem('profile');
        if (localUser) {
            const user: UserState = JSON.parse(localUser);
            return {
                User: completeUserData(user, user.token),
            };
        }
    } else {
        return {};
    }
};
